import { render, staticRenderFns } from "./ProductDisplayYearAndPrice.vue?vue&type=template&id=0bfcf7c4"
import script from "./ProductDisplayYearAndPrice.vue?vue&type=script&lang=js"
export * from "./ProductDisplayYearAndPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports